import camera from '../Assets/camera.webp';
import machine from '../Assets/machine.webp';
import zoom from '../Assets/zoom.webp';
import micro from '../Assets/micro.webp';
import perche from '../Assets/perche.webp';
import par from '../Assets/par.webp';
import gelatines from '../Assets/gelatines.webp';

function Materiel() {
  return (
    <div className="materiel-container">
      <h2>Vous pouvez louer le matériel Red-glitter Production !</h2>

      <div className="materiel-category">
        <h3>Notre matériel image :</h3>
        <div className="materiel-items">
          <div className="materiel-item">
            <img src={camera} alt="caméra" />
            <p>Canon EOS MARK 2</p>
          </div>
          <div className="materiel-item">
            <img src={machine} alt="machine à fumée" />
            <p>Machine à fumée</p>
          </div>
        </div>
      </div>

      <div className="materiel-category">
        <h3>Notre matériel son :</h3>
        <div className="materiel-items">
          <div className="materiel-item">
            <img src={zoom} alt="zoom" />
            <p>ZOOM H1 XLR</p>
          </div>
          <div className="materiel-item">
            <img src={micro} alt="micro" />
            <p>T.BONE EM 9900</p>
          </div>
          <div className="materiel-item">
            <img src={perche} alt="perche" />
            <p>RODE Micro Boompole</p>
          </div>
        </div>
      </div>

      <div className="materiel-category">
        <h3>Notre matériel lumière :</h3>
        <div className="materiel-items">
          <div className="materiel-item">
            <img src={par} alt="par" />
            <p>PAR 64</p>
          </div>
          <div className="materiel-item">
            <img src={gelatines} alt="gelatines" />
            <p>Gélatines</p>
          </div>
        </div>
      </div>

      <div className="materiel-tarifs">
        <h3>Contactez-nous pour connaître nos tarifs !</h3>
      </div>
    </div>
  );
}

export default Materiel;